import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { RotatingLines } from "react-loader-spinner";

const Loader = () => {
  return (
    <RotatingLines
    visible={true}
    height="50"
    width="50"
    strokeColor="#a6a6a6"
    strokeWidth="5"
    animationDuration="0.75"
    ariaLabel="rotating-lines-loading"
    wrapperStyle={{}}
    wrapperClass=""
    
    />   
  );
};

const styles = `
 .loader-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}`;

// Inject styles into the document
const styleSheet = document.createElement("style");
styleSheet.type = "text/css";
styleSheet.innerText = styles;
document.head.appendChild(styleSheet);

export default Loader;
